import store from '@/store/store.js'

const updateChildrenIntervalInSeconds = 60
const updateLicenseIntervalInSeconds  = 60
const updateRequestsIntervalInSeconds  = 60

class TimersManager {
  constructor() {
    this.updateChildrenTimer = null
    this.updateLicenseTimer = null
    this.updateRequestsTimer = null
    this.groupId = null
  }

  initTimers() {
    this.groupId = store.getters['auth/currentUser'].group_id

    this.initUpdateChildrenTimer()
    this.initUpdateLicenseTimer()
    this.initUpdateRequestsTimer()
  }

  initUpdateChildrenTimer() {
    if (!this.updateChildrenTimer) {
      this.updateChildrenTimer = setInterval(() => {
        if (store.getters['app/getVisibilityState'] === 'visible' && !store.getters['app/isUserInactive']) {
          store.dispatch('children/load', this.groupId)
        }
      }, updateChildrenIntervalInSeconds * 1000)
    }
  }

  initUpdateLicenseTimer() {
    if (!this.updateLicenseTimer) {
      this.updateLicenseTimer = setInterval(() => {
        store.dispatch('auth/setHasPaidLicense', this.groupId)
      }, updateLicenseIntervalInSeconds * 1000)
    }
  }

  initUpdateRequestsTimer() {
    if (!this.updateRequestsTimer) {
      this.updateRequestsTimer = setInterval(() => {
        if (store.getters['app/getVisibilityState'] === 'visible' && !store.getters['app/isUserInactive']) {
          store.dispatch('requests/load', this.groupId)
        }
      }, updateRequestsIntervalInSeconds * 1000)
    }
  }

  clearTimers() {
    clearInterval(this.updateChildrenTimer)
    clearInterval(this.updateLicenseTimer)
    clearInterval(this.updateRequestsTimer)

    this.updateChildrenTimer = null
    this.updateLicenseTimer = null
    this.updateRequestsTimer = null
  }
}

export default new TimersManager
